<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="deliveryDateConfirms"
        @select="selectOne"
        @select-all="selectAll">
      <!--      <div slot="toolbar">-->
      <!--        <el-button type="primary" @click="$refs.editDeliveryDateConfirm.open(0)">新建</el-button>-->
      <!--        <el-button type="danger" @click="deleteIds">批量删除</el-button>-->
      <!--      </div>-->
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="销售订单编号">
            <el-input v-model.trim="filter.salesOrderNo" clearable/>
          </vm-search>
          <vm-search label="SAP销售订单编号">
            <el-input v-model.trim="filter.sapSalesOrderNo" clearable/>
          </vm-search>
          <vm-search label="SAP行号">
            <el-input v-model.trim="filter.sapRowNo" clearable/>
          </vm-search>
          <vm-search label="状态">
            <el-select v-model.trim="filter.status" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.deliveryStatus)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="物料编号">
            <el-input v-model.trim="filter.materialNo" clearable/>
          </vm-search>
          <vm-search label="物料名称">
            <el-input v-model.trim="filter.materialName" clearable/>
          </vm-search>
          <vm-search label="回复者姓名">
            <el-input v-model.trim="filter.responderName" clearable/>
          </vm-search>
          <vm-search label="回复内容">
            <el-input v-model.trim="filter.responseContent" clearable/>
          </vm-search>
          <vm-search label="回复时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.responseTimeBegin"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 190px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.responseTimeEnd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 190px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column align="center" type="selection" width="55"/>
      <el-table-column align="center" prop="salesOrderNo" width="110" label="销售订单编号"/>
      <el-table-column align="center" prop="sapSalesOrderNo" width="130" label="SAP销售订单编号"/>
      <el-table-column align="center" prop="sapRowNo" width="110" label="SAP行号"/>
      <el-table-column align="center" prop="materialNo" width="110" label="物料编号"/>
      <el-table-column align="center" prop="materialName" width="300" label="物料名称"/>
      <el-table-column align="center" prop="quantity" label="数量"/>
      <el-table-column align="center" prop="status" label="状态">
        <template slot-scope="scope">
          <span>{{deliveryStatus[scope.row.status]}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="responderName" width="100" label="回复者姓名"/>
      <el-table-column align="center" prop="responseTime" width="140" label="回复时间"/>
      <el-table-column align="center" prop="responseContent" width="300" label="回复内容"/>
      <!--      <el-table-column-->
      <!--          label="操作"-->
      <!--          align="center"-->
      <!--          class-name="vm-table_operate"-->
      <!--          width="120px">-->
      <!--        <template slot-scope="scope">-->
      <!--&lt;!&ndash;          <el-button type="primary" @click="$refs.editDeliveryDateConfirm.open(scope.row.pkid)">编辑</el-button>&ndash;&gt;-->
      <!--          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </vm-table>
    <delivery-date-confirm-edit ref="editDeliveryDateConfirm" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import DeliveryDateConfirmEdit from "@/views/information/DeliveryDateConfirm/DeliveryDateConfirmEdit";
  export default {
    name: "DeliveryDateConfirmList",
    components: {DeliveryDateConfirmEdit, VmTable,VmSearch},
    data() {
      return {
        idList: "",
        constant,
        deliveryStatus: constant.deliveryStatus,
        filter: {
          salesOrderNo: "",
          sapSalesOrderNo: "",
          sapRowNo: "",
          status: "",
          materialNo: "",
          materialName: "",
          responderName: "",
          responseTimeBegin: "",
          responseTimeEnd: "",
          responseContent: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectOne(selection) {
        this.idList = selection;
        console.log(selection);
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.pkid);
          }
          console.log(ids);
          this.$http
            .delete("basic","deliveryDateConfirms/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","deliveryDateConfirms",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
